import { Component, OnInit, ViewChild, AfterViewInit } from '@angular/core';
import { faArrowDown } from '@fortawesome/free-solid-svg-icons';
import { faCheckCircle, faTimesCircle } from '@fortawesome/free-regular-svg-icons';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { SignaturePad } from 'angular2-signaturepad/signature-pad';
import { OfferService } from '../shared/services/offer-services/offer.service';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-sign-documents',
  templateUrl: './sign-documents.component.html',
  styleUrls: ['./sign-documents.component.sass']
})
export class SignDocumentsComponent implements OnInit, AfterViewInit {
  faCheckCircle = faCheckCircle;
  faTimesCircle = faTimesCircle;
  faArrowDown = faArrowDown;

  @ViewChild('codeModal', { static: false }) private codeModal;
  @ViewChild('offerDetailsModal', { static: false }) private offerDetailsModal;
  @ViewChild('questionnarieDetailsModal', { static: false }) private questionnarieDetailsModal;
  @ViewChild('signModal', { static: false }) private signModal;
  @ViewChild('signModal2', { static: false }) private signModal2;
  @ViewChild('alertModal', { static: false }) private alertModal;
  @ViewChild('succesModal', { static: false }) private succesModal;
  @ViewChild(SignaturePad, { static: false }) signaturePad: SignaturePad;
  @ViewChild(SignaturePad, { static: false }) signaturePad2: SignaturePad;

  codeForm = new FormGroup({
    code: new FormControl('', [Validators.required])
  })

  signaturePadOptions = {
    'minWidth': 2,
    'canvasWidth': 735,
    'canvasHeight': 300
  };

  validateCode: Boolean = false;

  offerID;
  token;
  offer;
  signer;

  constructor(private activatedRoute: ActivatedRoute, private modalService: NgbModal, private offerService: OfferService) {
    this.activatedRoute.queryParams.subscribe(params => {
      this.offerID = params['offerid'];
      this.token = params['token'];
    });
  }

  ngOnInit() {
  }

  ngAfterViewInit() {
    this.modalService.open(this.codeModal, { backdrop: 'static' })
  }

  checkCode() {
    if (this.codeForm.value.code) {
      this.offerService.checkOTPCode(this.offerID, this.token, this.codeForm.value.code)
        .then(
          (x: any) => {
            console.log(x);
            this.offer = x.offer;
            this.signer = x.signer;
            this.modalService.dismissAll();
            this.validateCode = true;
          },
          x => {
            this.modalService.open(this.alertModal, { backdrop: 'static' })
          }
        )
    } else {
      this.validateCode = false;
    }
  }
  pdfSrc1;
  pdfSrc;
  signDocument() {
    this.modalService.open(this.offerDetailsModal, { size: 'xl', backdrop: 'static' })
    this.offerService.previewDocument(this.offerID, 0, this.signer)
      .then(
        (x: any) => {
          // console.log(x)
          let pdfFile = new Blob([x.body], { type: 'application/pdf' });
          let urlPdf = window.URL.createObjectURL(pdfFile)
          this.pdfSrc1 = urlPdf
          // document.querySelector('iframe').src = urlPdf + "#zoom=130&toolbar=0"
          // console.log(urlPdf);
        }
      )
  }
  signDocument2() {
    this.modalService.open(this.questionnarieDetailsModal, { size: 'xl', backdrop: 'static' })
    this.offerService.previewDocument(this.offerID, 1, this.signer)
      .then(
        (x: any) => {
          // console.log(x)
          let pdfFile = new Blob([x.body], { type: 'application/pdf' });
          let urlPdf = window.URL.createObjectURL(pdfFile)
          this.pdfSrc = urlPdf
          // console.log(urlPdf);
        }
      )
  }

  openSignModal() {
    this.modalService.open(this.signModal, { size: 'lg', backdrop: 'static' })
  }
  openSignModal2() {
    this.modalService.open(this.signModal2, { size: 'lg', backdrop: 'static' })
  }

  completeSigning(sign) {
    let image = sign.toDataURL()
    if (this.signer == 2) {
      this.offerService.signAgentOTPDocument(this.offerID, this.signer, 0, image, 1)
        .then(
          (x: any) => {
            this.offer = x;
            this.modalService.dismissAll()
            console.log(x);
            if (x.agentFirstSignature && x.agentSecondSignature) {
              this.modalService.open(this.succesModal, { size: 'lg', backdrop: 'static' })
            }
          }
        )
    } else {
      this.offerService.signOTPDocument(this.offerID, this.signer, 0, image, 1)
        .then(
          (x: any) => {
            this.offer = x;
            this.modalService.dismissAll()
            console.log(x);
            if (this.signer == 0) {
              if (x.contractorFirstSignature && x.contractorSecondSignature) {
                this.modalService.open(this.succesModal, { size: 'lg', backdrop: 'static' })
              }
            } else {
              if (x.insureeFirstSignature && x.insureeSecondSignature) {
                this.modalService.open(this.succesModal, { size: 'lg', backdrop: 'static' })
              }
            }
          }
        )
    }
  }
  completeSigning2(sign) {
    let image = sign.toDataURL()
    if (this.signer == 2) {
      this.offerService.signAgentOTPDocument(this.offerID, this.signer, 1, image, 1)
        .then(
          (x: any) => {
            this.offer = x;
            this.modalService.dismissAll()
            console.log(x);
            if (x.agentFirstSignature && x.agentSecondSignature) {
              this.modalService.open(this.succesModal, { size: 'lg', backdrop: 'static' })
            }
          }
        )
    } else {
      this.offerService.signOTPDocument(this.offerID, this.signer, 1, image, 1)
        .then(
          (x: any) => {
            this.offer = x;
            this.modalService.dismissAll()
            console.log(x);
            if (this.signer == 0) {
              if (x.contractorFirstSignature && x.contractorSecondSignature) {
                this.modalService.open(this.succesModal, { size: 'lg', backdrop: 'static' })
              }
            } else {
              if (x.insureeFirstSignature && x.insureeSecondSignature) {
                this.modalService.open(this.succesModal, { size: 'lg', backdrop: 'static' })
              }
            }
          }
        )
    }
  }
  // completeSigning3(sign) {
  //   let image = sign.toDataURL()
  //   this.offerService.signOTPDocument(this.offerID, 2, 0, image, 1)
  //     .then(
  //       (x: any) => {
  //         this.offer = x;
  //         this.modalService.dismissAll()
  //         console.log(x);
  //         if (this.signer == 0) {
  //           if (x.contractorFirstSignature && x.contractorSecondSignature) {
  //             this.modalService.open(this.succesModal, { size: 'lg', backdrop: 'static' })
  //           }
  //         } else {
  //           if (x.insureeFirstSignature && x.insureeSecondSignature) {
  //             this.modalService.open(this.succesModal, { size: 'lg', backdrop: 'static' })
  //           }
  //         }
  //       }
  //     )
  // }
  // completeSigning4(sign) {
  //   let image = sign.toDataURL()
  //   this.offerService.signOTPDocument(this.offerID, 2, 1, image, 1)
  //     .then(
  //       (x: any) => {
  //         this.offer = x;
  //         this.modalService.dismissAll()
  //         console.log(x);
  //         if (this.signer == 0) {
  //           if (x.contractorFirstSignature && x.contractorSecondSignature) {
  //             this.modalService.open(this.succesModal, { size: 'lg', backdrop: 'static' })
  //           }
  //         } else {
  //           if (x.insureeFirstSignature && x.insureeSecondSignature) {
  //             this.modalService.open(this.succesModal, { size: 'lg', backdrop: 'static' })
  //           }
  //         }
  //       }
  //     )
  // }

  clearSign(sign) {
    sign.clear();
  }
}
